
import head from '../mixins/MetaHead'

export default {
    mixins: [head],
    data() {
        return {
            title: 'About FreeConvert.com – Fast & Easy Online File Conversion',
            desc:
                'Learn about FreeConvert, a top online file converter and compressor trusted by millions. Discover our mission, story, and tech powering 2M+ daily files.',
            currentUrl: '/about',
            byTheNumbersCards: [
                { title: '11 M+', subtitle: 'Monthly visitors' },
                { title: '2 M+', subtitle: 'Files processed every day' },
                { title: '3 K+', subtitle: 'File conversion & compression tools' },
                { title: '1.2 K+', subtitle: 'Files are processed every minute' },
                { title: '17 K+', subtitle: '4.7 Rating based on 17,000+ reviews' },
                { title: 'Top 2K+', subtitle: "Ranked in Alexa's Top 2000 websites in 2020" },
            ],
            technologyCards: [
                {
                    title: 'Frontend',
                    subtitle: '<a href="https://nuxtjs.org" target="_blank">NuxtJS</a>, <a href="https://vuejs.org" target="_blank">Vue.js</a>'
                },
                {
                    title: 'Backend',
                    subtitle: '<a href="https://nodejs.org" target="_blank">Node.js</a>, <a href="https://www.mongodb.com" target="_blank">MongoDB</a>'
                },
                {
                    title: 'Infrastructure',
                    subtitle: '<a href="https://aws.amazon.com" target="_blank">AWS</a>, <a href="https://azure.microsoft.com" target="_blank">Azure</a>'
                },
                {
                    title: 'Testing',
                    subtitle: '<a href="https://playwright.dev" target="_blank">Playwright</a>, <a href="https://www.usebruno.com" target="_blank">Bruno</a>'
                },
                {
                    title: 'Monitoring',
                    subtitle: '<a href="https://prometheus.io" target="_blank">Prometheus</a>, <a href="https://www.graylog.org" target="_blank">Graylog</a>, <a href="https://grafana.com" target="_blank">Grafana</a>'
                },
                {
                    title: 'Project Management',
                    subtitle: '<a href="https://www.atlassian.com/software/jira" target="_blank">Jira</a>'
                }
            ]
        }
    },
    components: {
        SecurityAndCompliance: () => import(/* webpackChunkName: "SecurityAndCompliance" */ "~/components/ui/SecurityAndCompliance")
    },
    mounted() {
        this.$store.commit('updateBreadcrumbs', [
            {
                url: this.localePath('/about'),
                label: this.$t('about_us')
            }
        ])
    }
}
